import { FilmFiltersOptions } from 'src/app/models/items/film-filters-options.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Component, inject, Inject, OnInit } from '@angular/core';
import { FilmService } from 'src/app/services/items/film.service';

@Component({
  selector: 'app-film-filters-options-dialog',
  templateUrl: './film-filters-options-dialog.component.html',
})
export class FilmFiltersOptionsDialogComponent implements OnInit {
  private _filmService: FilmService = inject(FilmService);

  public filtersOptions: FilmFiltersOptions = {
    languages: [],
    subtitles: [],
    categories: [],
  };
  public formGroup: FormGroup = new FormGroup({
    languages: new FormArray([]),
    subtitles: new FormArray([]),
    categories: new FormArray([]),
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FilmFiltersOptions | null,
    private _dialogRef: MatDialogRef<FilmFiltersOptionsDialogComponent>
  ) {}

  ngOnInit(): void {
    this._filmService.getFiltersOptions().subscribe({
      next: (response) => {
        this.filtersOptions = response.data as FilmFiltersOptions;
        this.initFormArrays();
      },
      error: (error: unknown) => console.info('ERROR:', error),
    });
  }

  private initFormArrays(): void {
    const formArrays = {
      languages: this.formGroup.get('languages') as FormArray,
      subtitles: this.formGroup.get('subtitles') as FormArray,
      categories: this.formGroup.get('categories') as FormArray,
    };

    formArrays.languages.clear();
    formArrays.subtitles.clear();
    formArrays.categories.clear();

    const isSelected = (
      category: keyof FilmFiltersOptions,
      value: string
    ): boolean => {
      return this.data?.[category]?.includes(value) ?? false;
    };

    this.filtersOptions.languages.forEach((lang) =>
      formArrays.languages.push(new FormControl(isSelected('languages', lang)))
    );
    this.filtersOptions.subtitles.forEach((sub) =>
      formArrays.subtitles.push(new FormControl(isSelected('subtitles', sub)))
    );
    this.filtersOptions.categories.forEach((cat) =>
      formArrays.categories.push(new FormControl(isSelected('categories', cat)))
    );
  }

  private _getSelectedValues(array: string[], controls: boolean[]): string[] {
    return array.filter((_, i) => controls[i]);
  }

  onReset() {
    this._dialogRef.close({ languages: [], subtitles: [], categories: [] });
  }

  onDismiss() {
    this._dialogRef.close({ languages: [], subtitles: [], categories: [] });
  }

  onConfirm() {
    const formValue = this.formGroup.value;
    const selectedFilters: FilmFiltersOptions = {
      languages: this._getSelectedValues(
        this.filtersOptions.languages,
        formValue.languages
      ),
      subtitles: this._getSelectedValues(
        this.filtersOptions.subtitles,
        formValue.subtitles
      ),
      categories: this._getSelectedValues(
        this.filtersOptions.categories,
        formValue.categories
      ),
    };

    this._dialogRef.close(selectedFilters);
  }
}
